import { Box, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import useStyles from "./style2.js";
import { useMediaQuery } from "@material-ui/core";

const CirclesBannerNosotros = (props) => {
  const classes = useStyles();
  const mobile = useMediaQuery("(max-width:768px)");

  return (
    <Box component="div" className={!mobile ? classes.about : classes.about2}>
      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circle2}>
          <AccessTimeIcon
            className={!mobile ? classes.iconAbout : classes.iconAboutMob}
          />
          <Typography
            className={!mobile ? classes.textAbout : classes.textAboutMob}
            p="true"
          >
            {props.circlesSettings.first}
          </Typography>
        </Box>
      </Box>
      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circle2}>
          <VerifiedUserIcon
            className={!mobile ? classes.iconAbout : classes.iconAboutMob}
          />
          <Typography
            className={!mobile ? classes.textAbout : classes.textAboutMob}
            p="true"
          >
            {props.circlesSettings.second}
          </Typography>
        </Box>
      </Box>
      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circle2}>
          <AttachMoneyIcon
            className={!mobile ? classes.iconAbout : classes.iconAboutMob}
          />
          <Typography
            className={!mobile ? classes.textAbout : classes.textAboutMob}
            p="true"
          >
            {props.circlesSettings.third}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CirclesBannerNosotros;
